import { t } from "i18next";

/** Resolved display info for an encounter status chip. */

var STATUS_MAP = {
  finished: {
    intent: "success",
    label: "Finished"
  },
  planned: {
    intent: "brand",
    label: "Scheduled"
  },
  "in-progress": {
    intent: "attention",
    label: "Ongoing"
  },
  arrived: {
    intent: "attention",
    label: "Ongoing"
  },
  triaged: {
    intent: "attention",
    label: "Ongoing"
  },
  cancelled: {
    intent: "urgent",
    label: "Cancelled"
  },
  onleave: {
    intent: "urgent",
    label: "Cancelled"
  }
};

/** Maps a FHIR encounter status string to the intent and label used by StatusChip. */
export function getEncounterStatusInfo(status) {
  var _STATUS_MAP$status$to;
  return (_STATUS_MAP$status$to = STATUS_MAP[status.toLowerCase()]) !== null && _STATUS_MAP$status$to !== void 0 ? _STATUS_MAP$status$to : {
    intent: "base",
    label: t("status_unknown") || "Unknown"
  };
}